<template>
  <div class="listing-wrap">
    <div class="content">
      <img
        src="@/assets/img/zy_complete.png"
        class="complete"
      >
      <div class="list">暂无车辆信息</div>
      <div class="login-button">
        <span
          class="submit"
          @click="addListing"
        >添加车辆查权益</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  methods: {
    addListing() {
      this.$router.push({
        name: 'addListing',
        query: {
          homePage: this.$route.query.homePage || ''
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.listing-wrap {
  width: 7.5rem;
  height: 100vh;
  font-family: PingFangSC-Regular;
  display: flex;
  // margin: 0 30px;
  position: relative;
  overflow: hidden;

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    padding: 0 30px;

    .complete {
      width: 180px;
      height: 180px;
      position: absolute;
      left: 60%;
      transform: translateX(-75%);
      top: 32px;
    }

    .list {
      position: absolute;
      // width: 110px;
      // height: 25px;
      font-size: 18px;
      left: 60%;
      transform: translateX(-80%);
      top: 210px;
      color: #787878;
    }

    .login-button {
      width: 85%;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      position: absolute;
      top: 300px;

      .submit {
        border-radius: 4px;
        display: inline-block;
        justify-content: center;
        line-height: 48px;
        // width: 315pt;
        height: 48px;
        background: #c0233f;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}
</style>
